import {
  instance as axios,
  setJwtToken,
} from "../../config/axiosInstance";

const qs = (data = {}) => {
  const params = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params[key] = value;
  });
  return new URLSearchParams(params).toString();
};

export const fetchOpsSummaryApi = async () => {
  return axios.get("/admin/operations-ecosystem/summary", setJwtToken());
};

export const fetchOpsSettingsApi = async () => {
  return axios.get("/admin/operations-ecosystem/settings", setJwtToken());
};

export const saveOpsSettingsApi = async (data) => {
  return axios.put("/admin/operations-ecosystem/settings", data, setJwtToken());
};

export const fetchOpsConsultantsApi = async (data = {}) => {
  return axios.get(`/admin/operations-ecosystem/consultants?${qs(data)}`, setJwtToken());
};

export const setOpsConsultantTierApi = async (data) => {
  return axios.put("/admin/operations-ecosystem/consultants/tier", data, setJwtToken());
};

export const autoAssignTop20Api = async () => {
  return axios.post("/admin/operations-ecosystem/consultants/auto-top20", {}, setJwtToken());
};

export const fetchOpsCustomersApi = async (data = {}) => {
  return axios.get(`/admin/operations-ecosystem/customers?${qs(data)}`, setJwtToken());
};

export const fetchOpsOffersApi = async () => {
  return axios.get("/admin/operations-ecosystem/offers", setJwtToken());
};

export const fetchOpsAudienceApi = async (data = {}) => {
  return axios.get(`/admin/operations-ecosystem/audience?${qs(data)}`, setJwtToken());
};

export const sendOpsWhatsappApi = async (data) => {
  return axios.post("/admin/operations-ecosystem/whatsapp-send", data, setJwtToken());
};

export const fetchOpsWhatsappLogsApi = async (data = {}) => {
  return axios.get(`/admin/operations-ecosystem/whatsapp-logs?${qs(data)}`, setJwtToken());
};
